// src/utils/authHelpers.js
// Helper utilities for Firebase Auth with dynamic imports
// Usano solo firebase/auth standard (nessun plugin native)

import { getAuthInstance } from "../firebase";

// Carichiamo firebase/auth solo quando serve
async function loadFirebaseAuth() {
  const mod = await import("firebase/auth");
  return {
    onAuthStateChanged: mod.onAuthStateChanged,
    signInWithEmailAndPassword: mod.signInWithEmailAndPassword,
    createUserWithEmailAndPassword: mod.createUserWithEmailAndPassword,
    updateProfile: mod.updateProfile,
    signOut: mod.signOut,
    updatePassword: mod.updatePassword,
    updateEmail: mod.updateEmail,
    reauthenticateWithCredential: mod.reauthenticateWithCredential,
    EmailAuthProvider: mod.EmailAuthProvider,
    sendPasswordResetEmail: mod.sendPasswordResetEmail,
  };
}

// Login con email/password
export async function signInWithEmail(email, password) {
  const fb = await loadFirebaseAuth();
  const auth = await getAuthInstance();
  return fb.signInWithEmailAndPassword(auth, email, password);
}

// Signup con email/password
export async function createUserWithEmail(email, password) {
  const fb = await loadFirebaseAuth();
  const auth = await getAuthInstance();
  return fb.createUserWithEmailAndPassword(auth, email, password);
}

// Aggiornamento profilo (displayName, photoURL, ecc.)
export async function updateUserProfile(updates) {
  const fb = await loadFirebaseAuth();
  const auth = await getAuthInstance();
  if (!auth.currentUser) throw new Error("No current user");
  return fb.updateProfile(auth.currentUser, updates);
}

// Logout
export async function signOutUser() {
  const fb = await loadFirebaseAuth();
  const auth = await getAuthInstance();
  return fb.signOut(auth);
}

// Cambio password
export async function updateUserPassword(newPassword) {
  const fb = await loadFirebaseAuth();
  const auth = await getAuthInstance();
  if (!auth.currentUser) throw new Error("No current user");
  return fb.updatePassword(auth.currentUser, newPassword);
}

// Cambio email
export async function updateUserEmail(newEmail) {
  const fb = await loadFirebaseAuth();
  const auth = await getAuthInstance();
  if (!auth.currentUser) throw new Error("No current user");
  return fb.updateEmail(auth.currentUser, newEmail);
}

// Re-autenticazione (per operazioni sensibili)
export async function reauthenticateUser(password) {
  const fb = await loadFirebaseAuth();
  const auth = await getAuthInstance();
  if (!auth.currentUser || !auth.currentUser.email) {
    throw new Error("No current user or email");
  }
  const credential = fb.EmailAuthProvider.credential(
    auth.currentUser.email,
    password,
  );
  return fb.reauthenticateWithCredential(auth.currentUser, credential);
}

// Password reset
export async function sendPasswordReset(email) {
  const fb = await loadFirebaseAuth();
  const auth = await getAuthInstance();
  return fb.sendPasswordResetEmail(auth, email);
}

// Current user
export async function getCurrentUser() {
  const auth = await getAuthInstance();
  return auth.currentUser;
}

// Listener di stato auth (usato in App.jsx)
export async function setupAuthStateListener(callback) {
  const fb = await loadFirebaseAuth();

  // IMPORTANT: prendiamo la vera istanza di auth dal nostro firebase.js
  const { getAuthInstance } = await import("../firebase");
  const authInstance = await getAuthInstance();

  return fb.onAuthStateChanged(authInstance, callback);
}
